<div *ngIf="isLoading">
    <div
        style="position: fixed;z-index: 900;width: 100vw;height: 100vh;opacity: 80;top: 0;left: 0;background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000"></mat-spinner>
</div>
<div *ngIf="data_report">
    <div>
        <div class="container">
            <div class="row justify-content-center" style="padding: 5% 0">
                <h1 class="lifedi-color" style="font-weight: bold">
                    {{ data_report.reportname }}
                </h1>
            </div>
            <h2 style="text-decoration: underline; font-weight: bold">
                {{ data_report.measure_name }}
            </h2>
            <h3>
                {{ data_report.report_description }}
            </h3>

            <div class="d-flex">
                <h4 class="box-header text-center my-3">
                    ผู้ทำแบบทดสอบ
                </h4>
            </div>

            <div *ngFor="let data of data_report.data">
                <h2 style=" text-decoration: underline; font-weight: bold; text-align: center;">
                    {{ data.ideal_type }}
                </h2>
                <div *ngFor="let ideal of data.ideal_data; let j = index" class="justify-content-center"
                    style="padding: 2% 0">
                    <div style="position: absolute; left: -5000px; width: 610px; height: 131px; ">
                        <div class="normalcase"
                            *ngIf=" ideal.ideal_value > ideal.value || ideal.ideal_value == ideal.value ">
                            <div id="sliderpdf{{ ideal.id }}" class="custom-slider" style="width: 60%">
                                <ngx-slider value="{{ ideal.value }}" highValue="{{ ideal.ideal_value }}"
                                    [options]="options[j]" style="margin: 0 auto"></ngx-slider>
                            </div>
                        </div>
                        <div class="specialcase" *ngIf="ideal.value > ideal.ideal_value">
                            <div id="sliderpdf{{ ideal.id }}" class="custom-slider" style="width: 60%">
                                <ngx-slider value="{{ ideal.value | number : '1.2-2' }}" highValue="{{ ideal.ideal_value }}"
                                    [options]="options[j]" style="margin: 0 auto"></ngx-slider>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 5vh">
                        <div class="col-lg-2 col-md-12 col-sm-12">
                            <h2 class="topic" [ngStyle]="{ color: data.COLOR_CODE }"
                                style="font-weight: bold; text-decoration: underline" class="lifedi-color">
                                {{ ideal.psy_name }}
                            </h2>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 normalcase" *ngIf="
                    ideal.ideal_value > ideal.value ||
                    ideal.ideal_value == ideal.value
                  ">
                            <div id="slider{{ ideal.id }}" class="custom-slider" style="margin: 0 auto; width: 60%">
                                <ngx-slider value="{{ ideal.value | number : '1.2-2' }}" highValue="{{ ideal.ideal_value }}"
                                    [options]="options[j]" style="margin: 0 auto"></ngx-slider>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 specialcase" *ngIf="ideal.value > ideal.ideal_value">
                            <div id="slider{{ ideal.id }}" class="custom-slider" style="margin: 0 auto; width: 60%">
                                <ngx-slider value="{{ ideal.value | number : '1.2-2' }}" highValue="{{ ideal.ideal_value }}"
                                    [options]="options[j]" style="margin: 0 auto"></ngx-slider>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <h2 class="lifedi-color" style="font-weight: bold">
                                ท่านได้ {{ ideal.value | number: '1.2-2' }} คะแนน
                            </h2>
                            <h2 style="font-weight: bold; color: #ffc90e">
                                คะแนนที่เหมาะสม {{ ideal.ideal_value | number : '1.2-2' }} คะแนน
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <hr style="width: 70%; text-align: center" />
            <div *ngFor="let data of data_report.data">
                <h2 style="
                text-decoration: underline;
                font-weight: bold;
                text-align: center;
              ">
                    {{ data.ideal_type }}
                </h2>
                <div *ngFor="let ideal of data.ideal_data" style="padding: 2% 0">
                    <h2 class="lifedi-color" style="font-weight: bold; text-decoration: underline">
                        {{ ideal.psy_name }}
                    </h2>
                    <h4 [innerText]="ideal.psy_description"></h4>
                    <h2 style="font-weight: bold">
                        คะแนนต่ำสุด : {{ ideal.min }} คะแนนสูงสุด : {{ ideal.max }}
                    </h2>
                    <h2 class="lifedi-color" style="font-weight: bold">
                        ท่านได้ {{ ideal.value | number: '1.2-2' }} คะแนน
                        <!-- อยู่ในช่วงคะแนน {{ ideal.range }} คะแนน -->
                    </h2>
                    <h4 style="padding-bottom: 3%" [innerText]="ideal.range_description"></h4>
                    <hr style="width: 70%; text-align: center" />
                </div>
            </div>

            <!-- informant -->
            <hr class="my-2 underline-blue">

            <div class="d-flex">
                <h4 class="box-header text-center my-3">
                    ผู้มีส่วนร่วมในแบบทดสอบนี้
                </h4>
            </div>

            <div *ngIf="data_report" class="informant-box my-3">
                <h4 class="text-header">
                    รายงานผลของผู้มีส่วนร่วมนี้เป็นของ
                </h4>
                <div class="d-flex">
                    <h4 *ngFor="let p of data_report.parances; let i = index" class="text-participant">
                        <span *ngIf="i !== 0">,</span>
                        {{ p.EMAIL }} ({{ p.TAG }})
                    </h4>
                </div>
            </div>

            <div *ngFor="let data of data_report.data2">
                <h2 style=" text-decoration: underline; font-weight: bold; text-align: center;">
                    {{ data.ideal_type }}
                </h2>
                <div *ngFor="let ideal2 of data.ideal_data; let j = index" class="justify-content-center"
                    style="padding: 2% 0">
                    <div style="position: absolute; left: -5000px; width: 610px; height: 131px; ">
                        <div class="normalcase"
                            *ngIf=" ideal2.ideal_value > ideal2.value || ideal2.ideal_value == ideal2.value ">
                            <div id="sliderpdfInformant{{ ideal2.id }}" class="custom-slider" style="width: 60%">
                                <ngx-slider value="{{ ideal2.value | number : '1.2-2' }}" highValue="{{ ideal2.ideal_value }}"
                                    [options]="options[j]" style="margin: 0 auto"></ngx-slider>
                            </div>
                        </div>
                        <div class="specialcase" *ngIf="ideal2.value > ideal2.ideal_value">
                            <div id="sliderpdfInformant{{ ideal2.id }}" class="custom-slider" style="width: 60%">
                                <ngx-slider value="{{ ideal2.value | number : '1.2-2' }}" highValue="{{ ideal2.ideal_value }}"
                                    [options]="options[j]" style="margin: 0 auto"></ngx-slider>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="padding-top: 5vh">
                        <div class="col-lg-2 col-md-12 col-sm-12">
                            <h2 class="topic" [ngStyle]="{ color: data.COLOR_CODE }"
                                style="font-weight: bold; text-decoration: underline" class="lifedi-color">
                                {{ ideal2.psy_name }}
                            </h2>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 normalcase" *ngIf="
                    ideal2.ideal_value > ideal2.value ||
                    ideal2.ideal_value == ideal2.value
                  ">
                            <div id="slider{{ ideal2.id }}" class="custom-slider" style="margin: 0 auto; width: 60%">
                                <ngx-slider value="{{ ideal2.value | number : '1.2-2' }}" highValue="{{ ideal2.ideal_value }}"
                                    [options]="options[j]" style="margin: 0 auto"></ngx-slider>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 specialcase" *ngIf="ideal2.value > ideal2.ideal_value">
                            <div id="slider{{ ideal2.id }}" class="custom-slider" style="margin: 0 auto; width: 60%">
                                <ngx-slider value="{{ ideal2.value | number : '1.2-2' }}" highValue="{{ ideal2.ideal_value }}"
                                    [options]="options[j]" style="margin: 0 auto"></ngx-slider>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12">
                            <h2 class="lifedi-color" style="font-weight: bold">
                                ท่านได้ {{ ideal2.value | number: '1.2-2' }} คะแนน
                            </h2>
                            <h2 style="font-weight: bold; color: #ffc90e">
                                คะแนนที่เหมาะสม {{ ideal2.ideal_value }} คะแนน
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <hr style="width: 70%; text-align: center" />
            <div *ngFor="let data of data_report.data2">
                <h2 style="
                text-decoration: underline;
                font-weight: bold;
                text-align: center;
              ">
                    {{ data.ideal_type }}
                </h2>
                <div *ngFor="let ideal2 of data.ideal_data" style="padding: 2% 0">
                    <h2 class="lifedi-color" style="font-weight: bold; text-decoration: underline">
                        {{ ideal2.psy_name }}
                    </h2>
                    <h4 [innerText]="ideal2.psy_description"></h4>
                    <h2 style="font-weight: bold">
                        คะแนนต่ำสุด : {{ ideal2.min }} คะแนนสูงสุด : {{ ideal2.max }}
                    </h2>
                    <h2 class="lifedi-color" style="font-weight: bold">
                        ท่านได้ {{ ideal2.value | number: '1.2-2' }} คะแนน
                    </h2>
                    <h4 style="padding-bottom: 3%" [innerText]="ideal2.range_description"></h4>
                    <hr style="width: 70%; text-align: center" />
                </div>
            </div>

            <div style="text-align: center; padding: 5% 0" *ngIf="data_report">
                <lifedi-btn lable="ดาวน์โหลด" (click)="filepdf('download')" customStyle="background: #005C3D; color: #FFFFFF; margin-top: 0px;
              padding: 0 25px;">
                </lifedi-btn>
            </div>
        </div>
    </div>
</div>